// extracted by mini-css-extract-plugin
export default {"forbidden":"methods_forbidden__rL18u","restrictedTo":"methods_restrictedTo__XFJys","crown":"methods_crown__PiT7Z"};